$hyoo_showcase $mol_page
	plugins /
		<= Theme $mol_theme_auto
	attr * mol_theme \$mol_theme_dark
	title @ \$mol applications
	tools /
		<= Lights $mol_lights_toggle
		<= Source $mol_link_source uri \https://github.com/hyoo-ru/showcase.hyoo.ru
		<= Offer_link $mol_link
			uri \https://offer.hyoo.ru
			sub /
				<= Offer_button $mol_button_major
					title <= offer_title @ \Order
	body / <= Scroll $mol_scroll sub <= apps /
		<= App_widgets $hyoo_showcase_app
			title <= app_widgets_title @ \$mol components
			details \https://mol.hyoo.ru/#!section=demos
		<= App_scout $hyoo_showcase_app
			title <= app_scout_title @ \Scout games
			details \https://scout.hyoo.ru/#gist=%D0%A1%D1%82%D0%B5%D0%BD%D0%BA%D0%B0%20%D0%BD%D0%B0%20%D1%81%D1%82%D0%B5%D0%BD%D0%BA%D1%83
		<= App_piterjs $hyoo_showcase_app
			title <= app_piterjs_title @ \PiterJS
			details \https://piterjs.org/
		<= App_shelter $hyoo_showcase_app
			title <= app_shelter_title @ \Shelters ERP
			details \https://shelter.hyoo.ru/#login=user
		<= App_fallacy $hyoo_showcase_app
			title <= app_fallacy_title @ \Fallacies collection
			details \https://fallacy.hyoo.ru/
		<= App_toys $hyoo_showcase_app
			title <= app_toys_title @ \Online store
			details \https://toys.hyoo.ru/#size=M/popular
		<= App_calc $hyoo_showcase_app
			title <= app_calc_title @ \Spreadsheet
			details \https://calc.hyoo.ru/#title=a*x**2%20%2B%20b*x%20%2B%20c%20%3D%200/A1=a/B2=6/A2=3/B1=b/C1=c/E1=D/E2=%3D%20B2**2%20-%204*A2*C2/G1=x1/G2=%3D%20%28%20-B2%20%2B%20sqrt%28E2%29%20%29%20%2F%202%20%2F%20A2/H1=x2/H2=%3D%20%28%20-B2%20-%20sqrt%28E2%29%20%29%20%2F%202%20%2F%20A2/C2=0
		<= App_notes $hyoo_showcase_app
			title <= app_notes_title @ \Notes
			details \https://notes.hyoo.ru/#
		<= App_invest $hyoo_showcase_app
			title <= app_invest_title @ \Investments
			details \https://invest.hyoo.ru/
		<= App_todomvc $hyoo_showcase_app
			title <= app_todomvc_title @ \ToDoMVC
			details \https://todomvc.hyoo.ru/
		<= App_life $hyoo_showcase_app
			title <= app_life_title @ \Life game
			details \https://life.hyoo.ru/#snapshot=0~1fffe~2ffff~20000~20001~10002~30000~6ffff~7ffff~7fffe~6fffe~6fffd~7fffd~80000~8fffc~a0000~a0001~afffc~afffb~14fffe~15fffd~15fffe~14fffd~-3~-fffd~-10003~-1fffd~-20002~-2fffe~-3ffff~-40000~-30001~-d0000~-e0000~-d0001~-c0001
		<= App_habhub $hyoo_showcase_app
			title <= app_habhub_title @ \Reader
			details \https://habhub.hyoo.ru/#gist=https%3A%2F%2Fapi.github.com%2Frepos%2Fnin-jin%2FHabHub%2Fissues%2F3
		<= App_questions $hyoo_showcase_app
			title <= app_questions_title @ \StackOverflow client
			details \https://mol.js.org/app/questions/-/#question=2003505
		<= App_slides $hyoo_showcase_app
			title <= app_slides_title @ \Slideshow
			details \https://slides.hyoo.ru/#slides=https%3A%2F%2Fnin-jin.github.io%2Fslides%2Forp%2F/slide=2
		<= App_iq $hyoo_showcase_app
			title <= app_iq_title @ \IQ tester
			details \https://iq.hyoo.ru/
		<= App_rdf $hyoo_showcase_app
			title <= app_rdf_title @ \RDF browser
			details \http://rdf.hyoo.ru/#uri=http%3A%2F%2Fdbpedia.org%2Fontology%2Fhead
		<= App_lamps $hyoo_showcase_app
			title <= app_lamps_title @ \Lamps database
			details \https://lamps.hyoo.ru/#lamp=1
		<= App_bench $hyoo_showcase_app
			title <= app_bench_title @ \Benchmark
			details \https://bench.hyoo.ru/#bench=https%3A%2F%2Fhyoo-ru.github.io%2Ftodomvc%2Fbenchmark%2F/sort=fill
		<= App_request $hyoo_showcase_app
			title <= app_request_title @ \HTTP Debug Tool
			details \https://http.hyoo.ru/#uri=https%3A%2F%2Fapi.github.com%2Frepos%2Fhyoo-ru%2Fmam_mol
		<= App_jsperf $hyoo_showcase_app
			title <= app_jsperf_title @ \JS Benchmarking Tool
			details \https://perf.js.hyoo.ru/#sources=%5B%22window.location.href%3B%22%2C%22document.location.href%3B%22%5D/prefix/postfix/optimized=true
		<= App_issues $hyoo_showcase_app
			title <= app_issues_title @ \GitHub projects comparison
			details \https://compare.github.hyoo.ru/#projects=hyoo-ru%2Fmam_mol%2Cfacebook%2Freact%2Cvuejs%2Fvue
		<= App_tree $hyoo_showcase_app
			title <= app_tree_title @ \Tree Sandbox
			details \https://tree.hyoo.ru/#pipeline=%24mol_tree2_from_string~%24mol_jack_transform~%24mol_tree2_js_to_text~%24mol_tree2_text_to_string~%24mol_js_eval/source=hack%20%2Bpipe%0A%09hack%20%7C%3E%20var%0A%09%09pipe%0A%09%09from%0A%09hack%20%3C%7C%20pipe%0A%09from%0A%0Ahack%20%2Bmath%0A%09hack%20square%20%28**%29%0A%09%09%3C%7C%0A%09%092%0A%09hack%20next%20%28%2B%29%0A%09%09%3C%7C%0A%09%091%0A%09from%0A%0Ahack%20%2Bdebug%0A%09hack%20log%20%28%29%0A%09%09console%0A%09%09%5B%5D%20%5Clog%0A%09%09%28%2C%29%20from%0A%09from%0A%0A%2Bpipe%20%2Bmath%20%2Bdebug%20%7B%3B%7D%0A%09%7C%3E%203%0A%09%7C%3E%20square%0A%09%7C%3E%20next%0A%09log%20%3C%7C%0A%09return%20%3C%7C%0A
		<= App_icons $hyoo_showcase_app
			title <= app_icons_title @ \Icons galery
			details \https://nin-jin.github.io/mol_icon/
		<= App_portal $hyoo_showcase_app
			title <= app_portal_title @ \Portal
			details \https://mol.hyoo.ru/#app=components

$hyoo_showcase_app $mol_link
	target \_blank
	uri <= details \
	preview \
	sub /
		<= Title $mol_view sub / <= title \
		<= Container $mol_view sub /
			<= Demo $mol_frame
				style * background-image <= background \
				uri <= details \
